export type ParsedMaterialFileName = {
  title: string;
  language: string;
  resourceType: string;
};

const FILE_NAME_REGEX = /^(?<title>[a-zA-Z\d_\-+ ]+?)[_\-+ ]+(?<language>[a-z]{2,3}(?:-[a-zA-Z]{2})?)\.(?<resourceType>pdf)$/;

const parseMaterialFileName = (fileName: string): ParsedMaterialFileName | undefined => {
  const groups = fileName.match(FILE_NAME_REGEX)?.groups;

  if (!groups) return undefined;

  const [code, region] = groups.language.split('-');

  return {
    title: groups.title.replace(/[_\-+\s]+/g, ' ').trim(),
    language: region ? `${code}-${region.toUpperCase()}` : code,
    resourceType: groups.resourceType,
  };
};

export default parseMaterialFileName;
